export const SEND_TOAST = 'SEND_TOAST';
